import React, { Component } from 'react'
import './index.less'
import {
  setDocumentTitle,
  setUidToken,
  getlang,
  setlang,
  inject,
  observer
} from '../../../helper/devTools.js'

import Swiper from 'swiper';
import 'swiper/swiper-bundle.min.css';
import Message from '../../../component/Message'
import brower from '../../../helper/brower'
import uploadImg from '../../../tools/uploadImage';
import { chooseImage as handleChooseImage, uploadFile as uploadFileImg } from '../../../helper/webviewFun'

@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.kqStore = this.props.store.register('activity/kingqueen')
    setDocumentTitle('King  & Queen')
  }
  state = {
    lang: {},
    messageTxt: "",
    registerRuleTab: 1,
    howPlayRuleTab: 1,
    reminderShow: false,
    language:'en',
    ruleShow: false,
    howPlayShow: false,
    rewardShow: false,
    registerShow: false,
    mainTab: 1,
    planTab: 1,
    titleTxt: "",
    imageUrl: "",
    imageShow: "",
    picList: []
  }

  async initLang() {
    let { language } = this.props.location.query
    language =await getlang(language)
    this.setState({
      lang: setlang(language, this.kqStore.data.lang),
      language: language,
    })
    console.log('language', language)
  }

  async initUid() {
    let uid = await setUidToken(this.props.location.query)
    console.log(uid, 'uid')
    return uid
  }

  async componentDidMount() {
    this.initLang()
    let uid = await this.initUid()
    await this.RunOnStart(uid)
  }

  // 初始化/接口请求初始化
  RunOnStart = async (uid) => {
    try {
      this.setState({
        uid: uid
      })
      let getUserInfo = await this.kqStore.GetUserInfoWeb(uid)
      if (getUserInfo && getUserInfo.code == 0) {
        this.setState({
          userInfo: getUserInfo.res
        })
      }
    } catch (error) {
      console.error(error)
      this.refs.msg.show("error")
    }
  }

  handleNoShow() {
    this.setState({
      reminderShow: false,
      ruleShow: false,
      howPlayShow: false,
      rewardShow: false,
      registerShow: false,
    })
  }

  openRules() {
    this.setState({
      reminderShow: true,
      ruleShow: true,
      titleTxt: "Rules"
    })
  }

  openQuestion() {
    this.setState({
      howPlayShow: true,
      reminderShow: true,
      titleTxt: "How to Play"
    })
  }

  openReward() {
    this.setState({
      rewardShow: true,
      reminderShow: true,
      titleTxt: "Reward"
    })
  }

  openRegister() {
    this.setState({
      registerShow: true,
      reminderShow: true,
      titleTxt: "Register"
    })
  }

  async uploadImage(files) {
    try {
      let res = await uploadImg(files)
      if (res && res.url) {
        this.setState({
          imageUrl: res.url
        })
      }
    } catch (error) {
      this.refs.msg.show(error)
    }
  }


  async onImgFileFn(e) {
    e.preventDefault()
    console.log(e.target.files)
    //获取图片文件，图片类型，图片大小
    const file = e.target.files[0]
    const type = file && file.type
    const size = file && file.size
    const regularType = ['image/png', 'image/jpg', 'image/jpeg']
    //图片类型限制
    if (regularType.indexOf(type.toLowerCase()) === -1) {
      this.refs.msg.show('Only supports PNG or JPG images!')
      return false
    }
    //图片大小限制
    if (size && size > 5242880) {
      // 5 * 1024 * 1024，size的单位是字节
      this.refs.msg.show('The image size should less than 5M!')
      return false
    }
    //图片文件转成base64格式
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onloadend = () => {
      this.setState({
        imageShow: reader.result
      })
    }

    this.uploadImage(e.target.files[0])

    // const formData = new FormData();
    // formData.append('file', e.target.files[0]);
    // this.setState({
    //   formData: formData
    // })

    e.target.value = '' // 清空上次图片数据，保证可以选择同一张图片
  }

  handleClearImage() {
    this.setState({
      imageShow: "",
      imageUrl: ""
    })
  }

  async androidUpload() {
    this.setState({
      imageUrl: "",
      imageShow: "",
      picList: [],
    })

    let maxAdd = 1  // 限定最大图片
    let params = {
      count: maxAdd > 0 ? maxAdd : 0,
      sizeType: 'compressed',
      mp4Enabled: false,
      os: brower.isAndroid() ? 2 : 1
    }
    try {
      // 推入图片功能
      await handleChooseImage(params, async (pic) => {
        // 1. 如果没有选择图片，跳出
        if (pic.length <= 0) {
          return
        }

        // 2. 保存数据，并且展示图片
        let list = this.state.picList
        for (let i = 0; i < pic.length; i++) {
          list.push(pic[i])
        }
        this.setState({
          imageShow: list && list[0] && list[0].imageData,
          picList: list
        })
        let map2 = []
        this.state.picList && this.state.picList.map((item, index) => {
          map2.push({
            filePath: item.path,
            fileType: item.image
          })
        })
        if (map2.length > 0) {
          await uploadFileImg(map2, async (d) => {
            let list = d
            // let list = JSON.parse(d)
            this.setState({
              imageUrl: list && list[0] && list[0].url,
            })
            return
          })
        }
      })
    }
    catch (error) {
      console.error(error)
      this.refs.msg.show(error)
    }
  }

  render() {
    return (
      <div className={`king-queen-wrapper-container`}>

        <Message ref="msg" />

        <div className="bg-filter"></div>

        <div className="banner">
          <div className="rules" onClick={() => { this.openRules() }}>Rules</div>
          <div className="reward" onClick={() => { this.openReward() }}>Reward</div>
        </div>


        {/* <div className="cd"></div>

        <div className="register-desc-content">
          <div className="tab-sel-main">
            <div className={`item ${this.state.registerRuleTab == 1 && "item-active"}`} onClick={() => { this.setState({ registerRuleTab: 1 }) }}>
              <span>Weekly Task</span>
            </div>
            <div className={`item ${this.state.registerRuleTab == 2 && "item-active"}`} onClick={() => { this.setState({ registerRuleTab: 2 }) }}>
              <span>Rank</span>
            </div>
          </div>
          <div className="content">
            <div className="weekly" style={{ display: `${this.state.registerRuleTab == 1 ? "block" : "none"}` }}>
              <div className="title1">Monday to Thursday:</div>
              <div className="desc">
                Take the mic for 8 hours,play 6 ludo games at the same time (escape is not counted),get 9000 gold and headers (4 days) after completion.
                <br />
                <br />
                After playing 6 more rounds,you can get an additional dynamic background image of the room (4 days)
              </div>
              <div className="title2">Friday to Sunday:</div>
              <div className="desc">
                Take the mic for 6 hours,play 4 ludo games at the same time (escape is not counted),get 8000 gold and headers (4 days) after completion.
                <br />
                <br />
                After playing 4 more rounds,you can get an additional dynamic background image of the room (3 days)
              </div>
            </div>
            <div className="rank" style={{ display: `${this.state.registerRuleTab == 2 ? "block" : "none"}` }}>
              <div className="title1">Rank:</div>
              <div className="desc">
                Participants who receive any gift during the event can enter the leaderboard.
                <br />
                <br />
                The list is sorted from high to low according to the received gift value.
                <br />
                <br />
                When users have the same gift value, the user who arrives first will be ranked first.
                <br />
                <br />
                After the event ends, the final reward will be issued according to the ranking .
              </div>
            </div>
          </div>
          <div className="register-btn">
            register
          </div>
        </div> */}


        <div className="tab-main">
          <div
            className={`task ${this.state.mainTab == 1 && "active"}`}
            onClick={() => { this.setState({ mainTab: 1 }) }}>
            Weekly Task
          </div>
          <div
            className={`rank ${this.state.mainTab == 2 && "active"}`}
            onClick={() => { this.setState({ mainTab: 2 }) }}>
            Rank
          </div>
        </div>



        <div
          className="weekly-task-plan-main"
          style={{
            display: `${this.state.mainTab == 1 ? "block" : "none"}`
          }}>
          <div className="tab-sel-main">
            <div
              className={`item ${this.state.planTab == 1 && "item-active"}`}
              onClick={() => { this.setState({ planTab: 1 }) }}>
              <span>Monday to Thursday</span>
            </div>
            <div
              className={`item ${this.state.planTab == 2 && "item-active"}`}
              onClick={() => { this.setState({ planTab: 2 }) }}>
              <span>Friday to Sunday</span>
            </div>
          </div>
          <div className="content">
            <div className="mask">
              <div className="register">
                <div className="btn" onClick={() => { this.openRegister() }}>Register</div>
                <div className="question" onClick={() => this.openQuestion()}></div>
              </div>
            </div>
            <div className="content-scroll">
              <div className="part-main">
                <div className="title">Part A:</div>
                <div className="reward-content">
                  <div className="items">
                    <div className="item">
                      <div className="pic">
                        <img src="/img/activity/kingqueen/gold.png" alt="" />
                      </div>
                      <div className="gold">8000 golds</div>
                    </div>
                    <div className="item">
                      <div className="pic">
                        <img src="/img/activity/kingqueen/gold.png" alt="" />
                      </div>
                      <div className="gold">8000 golds</div>
                    </div>
                  </div>
                  <div className="get">Get</div>
                </div>
                <div className="task-main">
                  <div className="task-item">
                    <div className="title">Tack mic (6/6)</div>
                    <div className="prog">
                      <div className="prog-inner"></div>
                    </div>
                  </div>
                  <div className="task-item">
                    <div className="title">Play ludo (4/4)</div>
                    <div className="prog">
                      <div className="prog-inner"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="line"></div>
              <div className="part-main">
                {/* <div className="mask">
                  <div className="lock">finish Part A to unlock</div>
                </div> */}
                <div className="title">Part B:</div>
                <div className="reward-content">
                  <div className="items">
                    <div className="item">
                      <div className="pic">
                        <img src="/img/activity/kingqueen/gold.png" alt="" />
                      </div>
                      <div className="gold">8000 golds</div>
                    </div>
                  </div>
                  <div className="get">Get</div>
                </div>
                <div className="task-main">
                  <div className="task-item">
                    <div className="title">Tack mic (6/6)</div>
                    <div className="prog">
                      <div className="prog-inner"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="medal-main">
            <div className="medal_title">Medal</div>
            <div className="medal-content">
              <div className="medal-item">
                <div className="lv-title">LV.1(7days)</div>
                <div className="pic">
                  <img src="/img/activity/kingqueen/gold.png" alt="" />
                </div>
                <div className="desc">complete 1 week</div>
              </div>
              <div className="medal-item">
                <div className="lv-title">LV.1(7days)</div>
                <div className="pic">
                  <img src="/img/activity/kingqueen/gold.png" alt="" />
                </div>
                <div className="desc">complete 1 week</div>
              </div>
              <div className="medal-item">
                <div className="lv-title">LV.1(7days)</div>
                <div className="pic">
                  <img src="/img/activity/kingqueen/gold.png" alt="" />
                </div>
                <div className="desc">complete 1 week</div>
              </div>
              <div className="medal-item">
                <div className="lv-title">LV.1(7days)</div>
                <div className="pic">
                  <img src="/img/activity/kingqueen/gold.png" alt="" />
                </div>
                <div className="desc">complete 1 week</div>
              </div>
            </div>
          </div>
        </div>








        <div
          className="rank-list"
          style={{
            display: `${this.state.mainTab == 2 ? "block" : "none"}`
          }}
        >
          <div className="rank-top">
            <div className="top1">
              <div className="head"></div>
              <img src="https://d57d7hz6h6y0z.cloudfront.net/app/image/202306081056422676uid100490.jpg" className='ava' alt="" />
            </div>
            <div className="top2">
              <div className="head"></div>
              <img src="https://d57d7hz6h6y0z.cloudfront.net/app/image/202306081056422676uid100490.jpg" className='ava' alt="" />
            </div>
            <div className="top3">
              <div className="head"></div>
              <img src="https://d57d7hz6h6y0z.cloudfront.net/app/image/202306081056422676uid100490.jpg" className='ava' alt="" />
            </div>
            <div className="top1-info">
              <div className="name">123</div>
              <div className="id">ID:123</div>
              <div className="gold">12M</div>
            </div>
            <div className="top2-info">
              <div className="name">123</div>
              <div className="id">ID:123</div>
              <div className="gold">12M</div>
            </div>
            <div className="top3-info">
              <div className="name">123</div>
              <div className="id">ID:123</div>
              <div className="gold">12M</div>
            </div>
          </div>
          <div className="rank-items">
            <div className="item">
              <div className="rank-index">1</div>
              <div className="info">
                <div className="ava">
                  <img src="/img/gold.png" alt="" />
                </div>
                <div className="person">
                  <div className="name">name</div>
                  <div className="id">uid:123123</div>
                </div>
              </div>
              <div className="gold">12M</div>
            </div>
            <div className="item">
              <div className="rank-index">1</div>
              <div className="info">
                <div className="ava">
                  <img src="/img/gold.png" alt="" />
                </div>
                <div className="person">
                  <div className="name">name</div>
                  <div className="id">uid:123123</div>
                </div>
              </div>
              <div className="gold">12M</div>
            </div>
            <div className="item">
              <div className="rank-index">1</div>
              <div className="info">
                <div className="ava">
                  <img src="/img/gold.png" alt="" />
                </div>
                <div className="person">
                  <div className="name">name</div>
                  <div className="id">uid:123123</div>
                </div>
              </div>
              <div className="gold">12M</div>
            </div>
          </div>
          <div className="rank-items-empty">
            No one on the leaderboard
          </div>
        </div>

        <div
          className="rank-my"
          style={{
            display: `${this.state.mainTab == 2 ? "flex" : "none"}`
          }}
        >
          <div className="rank-index">1</div>
          <div className="info">
            <div className="ava">
              <img src="/img/gold.png" alt="" />
            </div>
            <div className="person">
              <div className="name">name</div>
              <div className="id">uid:123123</div>
            </div>
          </div>
          <div className="gold">12M</div>
        </div>

        <div
          className="rank-my-no-register"
          style={{
            display: `${this.state.mainTab == 2 ? "flex" : "none"}`
          }}
        >
          <div className="rank-index">--</div>
          <div className="info">
            <div className="ava">
              <img src="/img/activity/kingqueen/person.png" alt="" />
            </div>
          </div>
          <div className="register">Register</div>
        </div>




        <div className="reminder-tips" style={{ display: `${this.state.reminderShow ? "block" : "none"}` }}>
          <div className="mask"></div>
          <div className="content-outer">
            <div className="close" onClick={() => { this.handleNoShow() }}></div>
            <div className="title">{this.state.titleTxt}</div>

            <div className="rule-content-inner" style={{ display: `${this.state.ruleShow ? "block" : "none"}` }}>
              <div className="rule-content">
                <div className="rule-title">Activity Content:</div>
                <div className="rule-main" dangerouslySetInnerHTML={{ __html: this.state.lang.ruleDesc || "" }}></div>
                <div className="rule-tips">
                  {this.state.lang.copyright}
                </div>
              </div>
            </div>

            <div className="how-play-content" style={{ display: `${this.state.howPlayShow ? "block" : "none"}` }}>
              <div className="tab-items">
                <div
                  onClick={() => {
                    this.setState({
                      howPlayRuleTab: 1
                    })
                  }}
                  className={`${this.state.howPlayRuleTab == 1 ? "item-active" : "item"}`}>
                  Weekly Task
                </div>
                <div
                  onClick={() => {
                    this.setState({
                      howPlayRuleTab: 2
                    })
                  }}
                  className={`${this.state.howPlayRuleTab == 2 ? "item-active" : "item"}`}>
                  Rank
                </div>
              </div>
              <div className="play-content">
                <div className="weekly" style={{ display: `${this.state.howPlayRuleTab == 1 ? "block" : "none"}` }}>
                  <div className="title1">Monday to Thursday:</div>
                  <div className="desc">
                    Take the mic for 8 hours,play 6 ludo games at the same time (escape is not counted),get 9000 gold and headers (4 days) after completion.
                    <br />
                    After playing 6 more rounds,you can get an additional dynamic background image of the room (4 days)
                  </div>
                  <div className="title2">Friday to Sunday:</div>
                  <div className="desc">
                    Take the mic for 6 hours,play 4 ludo games at the same time (escape is not counted),get 8000 gold and headers (4 days) after completion.
                    <br />
                    After playing 4 more rounds,you can get an additional dynamic background image of the room (3 days)
                  </div>
                </div>
                <div className="rank" style={{ display: `${this.state.howPlayRuleTab == 2 ? "block" : "none"}` }}>
                  <div className="title1">Rank:</div>
                  <div className="desc">
                    Participants who receive any gift during the event can enter the leaderboard.
                    <br />
                    <br />
                    The list is sorted from high to low according to the received gift value.
                    <br />
                    <br />
                    When users have the same gift value, the user who arrives first will be ranked first.
                    <br />
                    <br />
                    After the event ends, the final reward will be issued according to the ranking .
                  </div>
                </div>
              </div>
            </div>

            <div className="rule-reward-content" style={{ display: `${this.state.rewardShow ? "block" : "none"}` }}>
              <div className="reward-item">
                <div className="reward-title">No1</div>
                <div className="content">
                  <div className="item">
                    <div className="pic">
                      <img src="/img/activity/kingqueen/gold.png" alt="" />
                    </div>
                    <div className="name">VIP5</div>
                  </div>
                  <div className="item">
                    <div className="pic">
                      <img src="/img/activity/kingqueen/gold.png" alt="" />
                    </div>
                    <div className="name">VIP5</div>
                  </div>
                  <div className="item">
                    <div className="pic">
                      <img src="/img/activity/kingqueen/gold.png" alt="" />
                    </div>
                    <div className="name">VIP5</div>
                  </div>
                  <div className="item">
                    <div className="pic">
                      <img src="/img/activity/kingqueen/gold.png" alt="" />
                    </div>
                    <div className="name">VIP5</div>
                  </div>
                  <div className="item">
                    <div className="pic">
                      <img src="/img/activity/kingqueen/gold.png" alt="" />
                    </div>
                    <div className="name">VIP5</div>
                  </div>
                  <div className="item">
                    <div className="pic">
                      <img src="/img/activity/kingqueen/gold.png" alt="" />
                    </div>
                    <div className="name">VIP5</div>
                  </div>
                </div>
              </div>
              <div className="reward-item">
                <div className="reward-title">No1</div>
                <div className="content">
                  <div className="item">
                    <div className="pic">
                      <img src="/img/activity/kingqueen/gold.png" alt="" />
                    </div>
                    <div className="name">VIP5</div>
                  </div>
                  <div className="item">
                    <div className="pic">
                      <img src="/img/activity/kingqueen/gold.png" alt="" />
                    </div>
                    <div className="name">VIP5</div>
                  </div>
                  <div className="item">
                    <div className="pic">
                      <img src="/img/activity/kingqueen/gold.png" alt="" />
                    </div>
                    <div className="name">VIP5</div>
                  </div>
                  <div className="item">
                    <div className="pic">
                      <img src="/img/activity/kingqueen/gold.png" alt="" />
                    </div>
                    <div className="name">VIP5</div>
                  </div>
                  <div className="item">
                    <div className="pic">
                      <img src="/img/activity/kingqueen/gold.png" alt="" />
                    </div>
                    <div className="name">VIP5</div>
                  </div>
                  <div className="item">
                    <div className="pic">
                      <img src="/img/activity/kingqueen/gold.png" alt="" />
                    </div>
                    <div className="name">VIP5</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="register-content" style={{ display: `${this.state.registerShow ? "block" : "none"}` }}>
              <div className="main-content">
                <div className="form-item">
                  <div className="title">user name</div>
                  <div className="line"></div>
                  <div className="input">
                    {this.state.userInfo && this.state.userInfo.nickname}
                  </div>
                </div>
                <div className="form-item">
                  <div className="title">user id</div>
                  <div className="line"></div>
                  <div className="input">
                    {this.state.userInfo && this.state.userInfo.duid}
                  </div>
                </div>
                <div className="form-item">
                  <div className="title">user name</div>
                  <div className="line"></div>
                  <div className="input">
                    Wealth:{this.state.userInfo && this.state.userInfo.wealthLv} Chram:{this.state.userInfo && this.state.userInfo.charmLv}
                  </div>
                </div>
                <div className="pic-main">
                  <label className='img-input-label' htmlFor="upload" onClick={() => { this.androidUpload() }}>
                  </label>
                  <div className="img-show-box" style={{ display: `${this.state.imageShow ? "block" : "none"}` }}>
                    <img src={this.state.imageShow} alt="" />
                    <div className="img-close" onClick={() => { this.handleClearImage() }}></div>
                  </div>
                </div>
                <input
                  style={{ display: "none" }}
                  id='upload'
                  className='upload'
                  onChange={(event) => this.onImgFileFn(event)}
                  type='file'
                  name='fileSelect'
                  accept='image/*'
                  multiple="mutiple"
                />
                <div className="reg" onClick={() => { this.androidUpload() }}>Register</div>
              </div>
            </div>

          </div>
        </div>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/kingqueen/index.js